module.exports = __webpack_public_path__ + "img/home-page.faefc511.jpg";